
import React from 'react';

export function getTop3BySegment(elements, listaPilares, segmentKey, scopeId) {
  const aux_values = listaPilares.find(x => x.id === scopeId);
  const values = aux_values.l_vals.filter(x => x.elementId !== 0);

  //Indexar valores por elementId
  const valuesByElement = values.reduce((acc, v) => {
    if (!acc[v.elementId]) acc[v.elementId] = [];
    acc[v.elementId].push(v);
    return acc;
  }, {});
 
  //Agrupar elementos por segmento
  const grouped = elements.reduce((acc, el) => {
    const key = el[segmentKey] || "Sin dato";
    if (!acc[key]) acc[key] = [];
    acc[key].push(el);
    return acc;
  }, {});
 
  const result = Object.entries(grouped).map(([key, groupElements]) => {
    //Obtener valores SOLO de los elementos del grupo
    const allValues = groupElements.flatMap(el => valuesByElement[el.elementId] || []);
 
    //Agrupar por periodo (mes)
    const valuesByPeriod = allValues.reduce((acc, v) => {
      //Ignorar nulos / undefined / NaN
      if (v.scopeValue === null || v.scopeValue === undefined || isNaN(v.scopeValue)) {
        return acc;
      }
    
      if (!acc[v.periodId]) acc[v.periodId] = [];
      acc[v.periodId].push(Number(v.scopeValue));
    
      return acc;
    }, {});
 
    //Promedio por periodo (solo los que tienen datos en ese mes)
    const avgByPeriod = Object.entries(valuesByPeriod).map(([period, arr]) => {
      if (!arr || arr.length === 0) return null;
  
      return arr.reduce((sum, val) => sum + val, 0) / arr.length;
    }).filter(avg => avg !== null && !isNaN(avg));
 
    //Promedio general SOLO sobre meses con datos
    const finalAvg = avgByPeriod.length > 0 ? avgByPeriod.reduce((sum, val) => sum + val, 0) / avgByPeriod.length : null;
 
    return { key, avg: finalAvg };
  });
 
  return result.sort((a, b) => b.avg - a.avg);
}


export function getTop3BySegment2(elements, listaPilares, segmentKey, scopeId) {
  const aux_values = listaPilares.find(x => x.id === scopeId);
  const values = aux_values.l_vals.filter(x => x.elementId !== 0);

  // Indexar valores por elementId
  const valuesByElement = values.reduce((acc, v) => {
    if (!acc[v.elementId]) acc[v.elementId] = [];
    acc[v.elementId].push(v);
    return acc;
  }, {});

  // Agrupar por periodId
  const valuesByPeriod = Object.values(valuesByElement).flat().reduce((acc, item) => {
    if (!acc[item.periodId]) {
      acc[item.periodId] = {
        periodId: item.periodId,
        sum: 0,
        nonNullCount: 0
      };
    }

    if (item.scopeValue !== null && item.scopeValue !== undefined) {
      acc[item.periodId].sum += item.scopeValue;
      acc[item.periodId].nonNullCount += 1;
    }

    return acc;
  }, {});

  const averagesByPeriod = Object.values(valuesByPeriod).map(item => ({
    periodId: item.periodId,
    scopeValue: item.nonNullCount === 0
      ? null
      : item.sum / item.nonNullCount
  }));

  return averagesByPeriod;
}


export function  buildApexSeriesFromElements(item) {
	const elements = item?.l_elements ?? [];

	// 1. Obtener todos los períodos únicos y ordenarlos
	const periods = [
		...new Set(
			elements
				.map(x => x.periodId)
				.filter(x => x !== null && x !== undefined)
		)
	].sort((a, b) => a - b);

	// 2. Agrupar por contrato + proveedor
	const grouped = new Map();

	elements.forEach(element => {
		const serieName = `${element.contractCode} - ${element.supplierName}`;

		if (!grouped.has(serieName)) {
			grouped.set(serieName, {
				name: serieName,
				valuesByPeriod: new Map()
			});
		}

		grouped
			.get(serieName)
			.valuesByPeriod
			.set(element.periodId, element.scopeValue ?? null);
	});

	// 3. Armar series para ApexChart
	const series = Array.from(grouped.values()).map(group => {
		return {
			name: group.name,
			data: periods.map(periodId => {
				return group.valuesByPeriod.has(periodId)
					? group.valuesByPeriod.get(periodId)
					: null;
			})
		};
	});

	return {
		categories: periods.map(x => x.toString()),
		series
	};
};